<!-- <img class="project-image" src="/assets/sinosuidal.gif"/> -->
<!-- <div class="vh-centered-child">
</div> -->
<div class="vh-centered-child">
    <div class="author-info-wrapper">
        <div class="author-image-wrap">
            <img class="autor-image" src="assets/profile_image.jpg"/>
        </div>
        <div class="author-info">
            <span class="h11 adjust-margin">Notebook</span>
            <span class="author-name adjust-margin">Dibyajyoti Mohapatra</span>
            <span>Software Developer, VMware</span>
        </div>
    </div>
</div>